import { Outlet } from "react-router"
import Navbar from "../components/Navbar"

const Layout = () => {
    return<>
        <Navbar/>
        <Outlet/>

    </>
}

export default Layout